module.exports = __webpack_public_path__ + "static/media/icon-lock-shield.4f517ec8.svg";